import React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import EventDetail from './eventDetails';
import { API_URL, API_URL_getCourseWWWInfoPortal } from '../../config';
import './pulpit.css'
const SalesEvent = (props) => {
   let timeFrom = props.timeFrom.split(":")[0] + ":" + props.timeFrom.split(":")[1]
   let timeTo = props.timeTo.split(":")[0] + ":" + props.timeTo.split(":")[1]
   const [isClicked, setIsClicked] = useState(false) 
   const [details, setDetails]= useState({})
   let today = new Date();
   let day = today.getDate();
   let month = today.getMonth() + 1;
   let year = today.getFullYear();
   if (month < 10) {
       month = '0' + month;
   }
   const startDate = `${year}-${month}-${day}`;
   function getDetails(){
    let urlApi = `${API_URL_getCourseWWWInfoPortal}getCourseWWWInfoPortal`
    let jsonBody = {
        courseHeadingName: props.name, // 'Żwiry-K1', // TODO będzie przychodić w linku w gecie
        attendanceStartDate: `${startDate}`,
        current_LocalizationsID: '0',
    }
    fetch(
        
        `${urlApi}`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: null,
            },
            body: JSON.stringify(jsonBody),
        }
    )
        .then((response) => {
            return response.json();
        })
        .then((response) => {
            setDetails(response.body)
            setIsClicked(true)
        })
   }
   function setHeight(){
    if(isClicked){
        setIsClicked(false);
        setDetails({});
    }else{
    getDetails()}
    
    
   }
   useEffect(()=>{
    setIsClicked(false);
    setDetails({});
   },[])
    return (
        <>
            {isClicked?
            <div onClick={setHeight} className="SalesEventHeight">
            <p className="saleesEvent_title">{props.name}</p>
            <div className="saleesEvent_contentWrapper">
                <p className="">Początek:</p>
                <p className="saleesEvent_content">{timeFrom}</p>
            </div>
            <div className="saleesEvent_contentWrapper">
                <p className="">Koniec:</p>
                <p className="saleesEvent_content">{timeTo}</p>
            </div>
            <div className="saleesEvent_contentWrapper">
                <p className="">Instrukto:</p>
                <p className="saleesEvent_content">{details.instructorsList}</p>
            </div>
            <div className="saleesEvent_contentWrapper">
                <p className="">Styl tańca:</p>
                <p className="saleesEvent_content">{details.courseDanceStyle}</p>
            </div>
        </div>:<div onClick={()=>{setHeight()}} className="SalesEvent">
                <p className="saleesEvent_title">{props.name}</p>
                <div className="saleesEvent_contentWrapper">
                    <p className="">Początek:</p>
                    <p className="saleesEvent_content">{timeFrom}</p>
                </div>
                <div className="saleesEvent_contentWrapper">
                    <p className="">Koniec:</p>
                    <p className="saleesEvent_content">{timeTo}</p>
                </div>
            </div>}
            
        </>
    );
};

export default SalesEvent;
